import { dropBoolean } from 'utils/drops';

const getLançamentosFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'contabilizado',
    label: 'Contabilizado',
    type: 'select',
    options: dropBoolean,
  },
  {
    name: 'documento',
    column: 'lancamento',
    label: 'Nº do Documento',
    type: 'number',
  },
  {
    name: 'valor',
    column: 'lancamento',
    label: 'Valor',
    type: 'currency',
  },
  {
    name: 'usuario',
    column: 'lancamento',
    label: 'Usuário',
    type: 'select',
    options: drops?.Users,
    multiple: true,
  },
  {
    name: 'dtlanc.i',
    column: 'lancamento',
    label: 'Data de Lançamento Inicial',
    type: 'date',
    initial: true,
  },
  {
    name: 'dtlanc.f',
    column: 'lancamento',
    label: 'Data de Lançamento Final',
    type: 'date',
  },
  {
    name: 'planoentidade',
    label: 'Plano de Lançamento',
    type: 'select',
    options: drops?.Planoentidade,
    multiple: true,
  },
  {
    name: 'ctacred',
    column: 'contas',
    label: 'Conta de Crédito',
    type: 'select',
    options: drops?.Planoconta,
    multiple: true,
  },
  {
    name: 'ctadeb',
    column: 'contas',
    label: 'Conta de Débito',
    type: 'select',
    options: drops?.Planoconta,
    multiple: true,
  },
  {
    name: 'regra',
    column: 'contas',
    label: 'Regra Utilizada',
    type: 'number',
  },
  {
    name: 'historico',
    label: 'Histórico',
  },
];

export default getLançamentosFilterFields;
